import React, { useEffect, useRef, useState } from 'react'
import './Industries.scss'
import IndustriesWidget from 'src/components/IndustriesWidget'
import ContactForm from 'src/components/ContactForm'
import AdditionalSectorsWidget from 'src/components/AdditionalSectorsWidget'

const Industries = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const url = process.env.REACT_APP_URL
  const [dataFromChild, setDataFromChild] = useState(true)

  useEffect(() => {
    document.title = companyName + ' - Industries'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", `At ${companyName}, we deliver high-quality software solutions across a wide range of industries. Our contractors help customers to innovate, streamline, and solve technical challenges.`)
    }
    const linkCanonical = document.querySelectorAll("link[rel='canonical']")[0]
    linkCanonical.setAttribute('href', `${url}industries`)
  }, [])

  const handleDataFromChild = (bool) => {
    setDataFromChild(bool)
  }

  return (
    <>
      <section className="industries">
        <div className="section-heading">
          <div className="container">
            <h1>Industries</h1>
            <div className="section-description">
              At {companyName}, we deliver high-quality software solutions across a wide
              range of industries.
            </div>
          </div>
        </div>

        <div className="container">
          <div className="industries-left">
            <IndustriesWidget />
          </div>

          <div className="industries-right">
            <div className="contact black-bck">
              <h2 className="orange">Get in Touch</h2>
              <div className="section-description thin-gray">
                Interested in working with us?<br></br>
                Contact us to discuss your business needs.
              </div>
              <ContactForm sendDataToParent={handleDataFromChild} />
            </div>
            <AdditionalSectorsWidget />
          </div>
        </div>
      </section>
    </>
  )
}

export default Industries